import React from 'react';

const DealContext = React.createContext({});

export default DealContext;
